<script>

import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
export default {
    name: "UpdatePrModal",
    components: {
        ItemCategory,
        Unit,
    },
    props: {
        fromProcurement: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                id: 0,
                apiResourceId: null,
                itemName: null,
                description: null,
                itemCategoryId: null,
                itemCategoryName: null,
                unitId: null,
                unitName: null
            },
            submitted: false
        };
    },
    validations: {
        form: {
            itemName: {required},
            description: {required}
        }
    },
    methods: {
        updateDescriptionSubmit(){
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            this.$emit('dropData', this.form);
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.form.itemCategoryId = data.id;
            this.form.itemCategoryName = data.name;
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.form.unitName = data.shortName;
            this.form.unitId = data.id;
        },
        transferData(parentData) {
            this.submitted = false;
            this.form = cloneDeep(parentData);
        }
    }
}
</script>
<template>
  <div>
    <b-modal
        id="update-description-modal"
        title="Update Description"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="updateDescriptionSubmit" class="needs-validation">
            <div>
                <div class="mb-3" >
                    <!-- v-if="$store.state.decrypt.isAdmin() || fromProcurement" -->
                    <label for="description">Item Name</label>
                    <textarea
                        rows="3"
                        id="itemName"
                        type="text"
                        autocomplete="off"
                        v-model="form.itemName"
                        placeholder="Enter Item Name..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.form.itemName.$error}"
                    ></textarea>
                    <div v-if="$v.form.itemName.$error" class="invalid-feedback">
                        <span v-if="!$v.form.itemName.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3" >
                    <label for="description">Description </label>
                    <textarea
                        id="descriptionCopy"
                        rows="3"
                        v-model="form.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.form.description.$error}"
                    ></textarea>
                    <div v-if="$v.form.description.$error" class="invalid-feedback">
                        <span v-if="!$v.form.description.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description">Item Category </label>
                    <b-input-group>
                        <template #append>
                            <b-button 
                                @click="getItemCategory"
                                variant="outline-info"
                            >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Item Category..."
                            class="form-control text-warning"
                            v-model="form.itemCategoryName"
                        />
                    </b-input-group>
                </div>
                <div class="mb-3">
                    <label for="description">Unit </label>
                    <b-input-group>
                        <template #append>
                            <b-button
                                @click="getUnit"
                                variant="outline-info"
                            >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Unit..."
                            class="form-control text-warning"
                            v-model="form.unitName"
                        />
                    </b-input-group>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Update
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('update-description-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
    <item-category @dropData="dropItemCat($event)"></item-category>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
  </div>
</template>